import Icon from "@material-ui/icons/Person";
import PermissionCreate from "./PermissionCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "studentPermissions",
  create: PermissionCreate,
  icon: Icon,
};
